<template>
  <FormSubmitPopup
    :title="title"
    v-model="value"
    :rightMethod="onSubmitted"
    @popupClose="$emit('input', false)"
    :rightButtonText="$t('submit')"
    ref="formPopup"
    hasAlert
    large
  >
    <template v-slot:input>
      <v-container py-0 fluid>
        <v-layout row>
          <v-flex xs12>
            <v-autocomplete
              hide-details
              :items="labelTemplates"
              return-object
              :label="$t('template')"
              item-text="name"
              @change="applyLabelTemplate"
            ></v-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex md6>
            <v-card width="100%">
              <v-card-text>
                <v-layout align-baseline>
                  <v-flex class="title" md3>{{ $t('sender') }}: </v-flex>
                  <v-flex md4>
                    <vite-autocomplete
                      hide-details
                      :items="fromAddress"
                      name="address-template-name"
                      return-object
                      :label="$t('addressName')"
                      v-model="fromTemplate"
                      item-text="siteName"
                      item-value="key"></vite-autocomplete>
                  </v-flex>
                  <v-flex md2>
                    <v-checkbox hide-details :label="$t('save')"  class="checkbox" v-model="isSaveFrom"></v-checkbox>
                  </v-flex>
                  <v-flex md2 v-if="!isSaveFrom">
                    <v-btn flat color="primary" @click="toggleParseAddress('isShowFromParseAddress', 'parseFormAddress', from)">{{$t('parseAddress')}}</v-btn>
                  </v-flex>
                  <v-flex md4 v-else>
                    <v-text-field
                      hide-details
                      :label="$t('addressName')"
                      v-model.trim="from.siteName"
                      v-if="isSaveFrom"
                      :rules="[ fieldIsRequired('Site name'), validAddressSiteName(isSaveFrom, isSaveSoldTo, thirdPartyInfo, isSaveTo, to)]"
                      class="required_field"></v-text-field> 
                  </v-flex>
                </v-layout>
                <v-layout v-if="isShowFromParseAddress">
                  <v-textarea
                    :label="$t('fullAddress')"
                    v-model.trim="parseFormAddress"
                    outline
                    rows="3"
                    hide-details
                  >
                  </v-textarea>
                </v-layout>
                <v-layout justify-space-between>
                  <v-flex xs7>
                    <v-layout justify-space-between>
                      <v-flex xs5>
                        <v-text-field
                          hide-details
                          :label="$t('fullName')"
                          v-model.trim="from.fullName"
                          :rules="[ fieldIsRequired('Full name'), fieldCharLimit('Full name', 35) ]"
                          class="required_field"
                        ></v-text-field> 
                      </v-flex>
                      <v-flex xs5>
                        <v-layout justify-space-between>
                          <v-flex v-bind="{ xs7: currentShippingService.isSupportFromExt, xs12: !currentShippingService.isSupportFromExt }">
                            <v-text-field
                              hide-details
                              :label="$t('phone')"
                              v-model.trim="from.phone"
                            ></v-text-field>
                          </v-flex>
                          <v-flex v-if="currentShippingService.isSupportFromExt" xs4>
                            <v-text-field
                              hide-details
                              :label="$t('extension')"
                              v-model.trim="from.extension"
                              :rules="[fieldCharLimit('extension', 6)]"
                            >
                            </v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      hide-details
                      :label="$t('companyName')"
                      v-model.trim="from.company"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout justify-space-between>
                  <v-flex xs7>
                    <v-text-field
                      hide-details
                      :label="`${$t('address')} 1`"
                      v-model.trim="from.address1"
                      :rules="[fieldIsRequired('Address'), fieldCharLimit('Address1', 50)]"
                      class="required_field"></v-text-field>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      hide-details
                      :label="`${$t('address')} 2`"
                      :rules="[fieldCharLimit('Address2', 50)]"
                      v-model.trim="from.address2"
                      ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout justify-space-between>
                  <v-flex xs7>
                    <v-layout justify-space-between>
                      <v-flex xs5>
                        <v-text-field
                          hide-details
                          :label="$t('city')"
                          v-model.trim="from.city"
                          :rules="[fieldIsRequired('City')]"
                          class="required_field"
                          ></v-text-field>
                      </v-flex>
                      <v-flex xs5>
                        <vite-autocomplete
                          v-if="fromStates.length"
                          hide-details
                          :items="fromStates"
                          v-model="from.state"
                          :label="$t('state')"
                          :rules="[fieldIsRequired('State'), v => !fromStates.includes(v) && `must be in ${fromStates}`]"
                          class="required_field"
                        />
                        <v-text-field
                          v-else
                          hide-details
                          :label="$t('state')"
                          v-model.trim="from.state"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      hide-details
                      :label="$t('zipCode')"
                      v-model.trim="from.zipCode"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout justify-space-between>
                  <v-flex xs7>
                    <v-layout justify-space-between>
                      <v-flex xs5 v-if="isDHL">
                        <vite-autocomplete
                          hide-details
                          :items="fromTaxNumberTypes"
                          item-text="name"
                          item-value="value"
                          v-model="from.taxNumberType"
                          :label="$t('taxNumberType')"
                        ></vite-autocomplete>
                        <!-- <v-text-field
                          hide-details
                          label="EIN"
                          v-model.trim="from.partyId"></v-text-field> -->
                      </v-flex>
                      <v-flex v-bind="[isDHL ? 'xs5' : 'xs7']">
                        <v-text-field
                          hide-details
                          :label="$t('email')"
                          v-model.trim="from.email"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs4>
                    <vite-autocomplete
                      hide-details
                      :items="allowedCountriesItems"
                      item-text="name"
                      item-value="value"
                      v-model="from.countryCode"
                      :label="$t('country')"
                      :rules="[v => !allowedCountries.includes(v) && `must be in ${allowedCountries}`]"
                      class="required_field" 
                    />
                  </v-flex>
                </v-layout>
                <!-- <v-layout justify-space-between>
                  <v-flex xs12>
                    <vite-autocomplete
                      hide-details
                      :items="fromTaxNumberTypes"
                      item-text="name"
                      item-value="value"
                      v-model="from.taxNumberType"
                      :label="$t('taxNumberType')"
                    ></vite-autocomplete>
                  </v-flex>
                </v-layout> -->
                <v-layout v-if="isDHL && from.taxNumberType" justify-space-between>
                  <v-flex xs7>
                    <v-layout justify-space-between>
                      <v-flex xs5>
                        <v-text-field
                          hide-details
                          :label="$t('taxNumber')"
                          v-model.trim="from.taxNumber"
                          :rules="[fieldIsRequired()]"
                          class="required_field"></v-text-field>
                        </v-flex>
                        <v-flex xs5>
                          <vite-autocomplete
                            hide-details
                            :items="countryCodeArray"
                            item-text="name"
                            item-value="value"
                            v-model="from.taxNumberCountry"
                            :label="$t('taxNumberCountry')"
                            :rules="[fieldIsRequired()]"
                            class="required_field">
                          </vite-autocomplete>
                        </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs4>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex md6>
            <v-card width="100%">
              <v-card-text>
                <v-layout align-baseline>
                  <v-flex class="title" md3>{{ $t('recipient') }}: </v-flex>
                  <v-flex md4>
                    <vite-autocomplete
                      hide-details 
                      :items="addresses"
                      return-object
                      :label="$t('addressName')"
                      v-model="toTemplate"
                      item-text="siteName"
                      item-value="siteName"></vite-autocomplete>
                  </v-flex>
                  <v-flex md2>
                    <v-checkbox hide-details :label="$t('save')" v-model="isSaveTo" class="checkbox"></v-checkbox>
                  </v-flex>
                  <v-flex md2 v-if="!isSaveTo">
                    <v-btn flat color="primary" @click="toggleParseAddress('isShowToParseAddress', 'parseToAddress', to)">{{$t('parseAddress')}}</v-btn>
                  </v-flex>
                  <v-flex md4>
                    <v-text-field
                      hide-details
                      :label="$t('addressName')"
                      v-model.trim="to.siteName"
                      v-if="isSaveTo"
                      :rules="[ fieldIsRequired('Site name'),  validAddressSiteName(isSaveTo, isSaveFrom, from, isSaveSoldTo, thirdPartyInfo)]"
                      class="required_field"></v-text-field> 
                  </v-flex>
                </v-layout>
                <v-layout v-if="isShowToParseAddress">
                  <v-textarea
                    :label="$t('fullAddress')"
                    v-model.trim="parseToAddress"
                    outline
                    rows="3"
                    hide-details
                  >
                  </v-textarea>
                </v-layout>
                <v-layout justify-space-between>
                  <v-flex xs7>
                    <v-layout justify-space-between>
                      <v-flex xs5>
                        <v-text-field
                          hide-details
                          :label="$t('fullName')"
                          v-model.trim="to.fullName"
                          :rules="[ fieldIsRequired('Full name'), fieldCharLimit('Full name', 35) ]"
                          class="required_field"
                        />
                      </v-flex>
                      <v-flex xs5>
                        <v-layout justify-space-between>
                          <v-flex v-bind="{ xs7: currentShippingService.isSupportToExt, xs12: !currentShippingService.isSupportToExt }">
                            <v-text-field
                              hide-details
                              :label="$t('phone')"
                              v-model.trim="to.phone"
                            ></v-text-field>
                          </v-flex>
                          <v-flex v-if="currentShippingService.isSupportToExt" xs4>
                            <v-text-field
                              hide-details
                              :label="$t('extension')"
                              v-model.trim="to.extension"
                              :rules="[fieldCharLimit('extension', 6)]"
                            >
                            </v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      hide-details
                      :label="$t('companyName')"
                      v-model.trim="to.company"
                    />
                  </v-flex>
                </v-layout>
                <v-layout justify-space-between>
                  <v-flex xs7>
                    <v-text-field
                      hide-details
                      :label="`${$t('address')} 1`"
                      v-model.trim="to.address1"
                      :rules="[fieldIsRequired('Address'), fieldCharLimit('address', 50)]"
                      class="required_field"></v-text-field>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      hide-details
                      :label="`${$t('address')} 2`"
                      :rules="[fieldCharLimit('Address2', 50)]"
                      v-model.trim="to.address2"
                      ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout justify-space-between>
                  <v-flex xs7>
                    <v-layout justify-space-between>
                      <v-flex xs5>
                        <v-text-field
                          hide-details
                          :label="$t('city')"
                          v-model.trim="to.city"
                          :rules="[fieldIsRequired('City')]"
                          class="required_field"
                          ></v-text-field>
                      </v-flex>
                      <v-flex xs5>
                        <vite-autocomplete
                          hide-details
                          :items="states"
                          v-model="to.state"
                          :label="$t('state')"
                          :rules="[fieldIsRequired('State')]"
                          class="required_field"
                        >
                          <template v-slot:item="data">
                            <template>
                              <v-list-tile-content>
                                <v-list-tile-title :id="data.item">
                                  {{data.item}}
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </template>
                          </template>
                        </vite-autocomplete>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs4>
                    <v-layout justify-space-around align-baseline>
                      <v-flex>
                        <v-text-field
                          hide-details
                          :label="$t('zipCode')"
                          v-model.trim="to.zipCode"
                          :rules="[fieldIsRequired('Zip code')]"
                          class="required_field"></v-text-field>    
                      </v-flex>
                      <v-flex xs2>
                        <v-tooltip top>
                          <template v-slot:activator="{on}">
                            <v-btn :disabled="googleMapDisabled" icon flat v-on="on" color="primary" @click.stop="goToGoogleMapLink" small><v-icon>location_on</v-icon></v-btn>
                          </template>
                          <span> {{ $t('googleMap') }}</span>
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                    </v-flex>
                </v-layout>
                <v-layout justify-space-between>
                  <v-flex xs7>
                    <v-layout justify-space-between>
                      <v-flex v-if="isDHL" xs5>
                        <vite-autocomplete
                          hide-details
                          :items="toTaxNumberTypes"
                          item-text="name"
                          item-value="value"
                          v-model="to.taxNumberType"
                          :label="$t('taxNumberType')"
                        ></vite-autocomplete>
                        <!-- <v-text-field
                          hide-details
                          label="EIN"
                          v-model.trim="to.partyId"></v-text-field> -->
                      </v-flex>
                      <v-flex v-bind="[isDHL ? 'xs5' : 'xs7']">
                        <v-text-field
                          hide-details
                          :label="$t('email')"
                          v-model.trim="to.email"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs4>
                    <vite-autocomplete
                      hide-details
                      :items="[{
                        name: $t('unitedStates'),
                        value: 'US'
                      }]"
                      item-text="name"
                      item-value="value"
                      v-model="to.countryCode"
                      :label="$t('country')"
                      :rules="[v => v !== 'US' && 'must be us']"
                      class="required_field"></vite-autocomplete>
                  </v-flex>
                </v-layout>
                <!-- <v-layout justify-space-between>
                  <v-flex xs12>
                    <vite-autocomplete
                      hide-details
                      :items="toTaxNumberTypes"
                      item-text="name"
                      item-value="value"
                      v-model="to.taxNumberType"
                      :label="$t('taxNumberType')"
                    ></vite-autocomplete>
                  </v-flex>
                </v-layout> -->
                <v-layout v-if="isDHL && to.taxNumberType" justify-space-between>
                  <v-flex xs7>
                    <v-layout justify-space-between>
                      <v-flex xs5>
                        <v-text-field
                          hide-details
                          :label="$t('taxNumber')"
                          v-model.trim="to.taxNumber"
                          :rules="[fieldIsRequired()]"
                          class="required_field"></v-text-field>
                        </v-flex>
                        <v-flex xs5>
                          <vite-autocomplete
                            hide-details
                            :items="countryCodeArray"
                            item-text="name"
                            item-value="value"
                            v-model="to.taxNumberCountry"
                            :label="$t('taxNumberCountry')"
                            :rules="[fieldIsRequired()]"
                            class="required_field">
                          </vite-autocomplete>
                        </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      hide-details
                      :label="$t('taxesPaidAmount')"
                      :rules="[v => isNaN(v) && $t('fieldIsNumber', { fieldName: 'This field' }), fieldIsRequired()]"
                      v-model.number="to.taxesPaidAmount"
                      class="required_field"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row v-if="isFEDEX && ['CA'].includes(from.countryCode)">
          <v-flex>
            <v-card width="100%">
              <v-card-text>
                <v-layout class="title" align-baseline justify-space-between>
                  <v-flex md2>
                    {{ $t('exportDetail') }}:
                  </v-flex>
                  <v-flex xs2>
                    <v-text-field
                      hide-details
                      :label="$t('permitNumber')"
                      :rules="[
                        // fieldIsRequired('permitNumber'),
                        fieldCharRange('permitNumber', 5, 10)
                      ]"
                      v-model.trim="exportDetail.permitNumber"></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <vite-autocomplete
                      hide-details
                      :items="cedFilings"
                      v-model="exportDetail.cedFiling"
                      item-text="label"
                      item-value="value"
                      :label="$t('cedFiling')"
                      :rules="[fieldIsRequired('cedFiling')]"
                      class="required_field"
                    >
                      <template v-slot:item="data">
                        <template>
                          <v-list-tile-content>
                            <v-list-tile-title :id="data.item">
                              {{data.item}}
                            </v-list-tile-title>
                          </v-list-tile-content>
                        </template>
                      </template>
                    </vite-autocomplete>
                  </v-flex>
                  <v-flex xs2>
                    <vite-autocomplete
                      hide-details
                      :items="exemptionNumbers"
                      v-model="exportDetail.exemptionNumber"
                      :label="$t('exemptionNumber')"
                      :rules="[fieldIsRequired('exemptionNumber')]"
                      class="required_field"
                    >
                      <template v-slot:item="data">
                        <template>
                          <v-list-tile-content>
                            <v-list-tile-title :id="data.item">
                              {{data.item}}
                            </v-list-tile-title>
                          </v-list-tile-content>
                        </template>
                      </template>
                    </vite-autocomplete>
                  </v-flex>
                  <v-flex xs2></v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row v-if="isFEDEX">
          <v-flex>
            <v-card width="100%">
              <v-card-text>
                <v-layout class="title" align-baseline>
                  <v-flex xs2>
                    {{ $t('thirdParty') }}:
                  </v-flex>
                  <v-flex md4>
                    <v-checkbox 
                      class="thirdPartySold" 
                      :hide-details="true" 
                      :label="$t('thirdPartySold')" 
                      v-model="isThirdParty" 
                    />
                  </v-flex>
                  <template v-if="isThirdParty">
                    <v-flex md2>
                      <vite-autocomplete
                        hide-details
                        :items="addresses"
                        name="address-template-name"
                        return-object
                        :label="$t('addressName')"
                        v-model="soldToTemplate"
                        item-text="siteName"
                        item-value="key">
                      </vite-autocomplete>
                    </v-flex>
                    <v-flex md2>
                      <v-checkbox hide-details :label="$t('save')"  class="checkbox" v-model="isSaveSoldTo"></v-checkbox>
                    </v-flex>
                    <v-flex md4>
                      <v-text-field
                        hide-details
                        :label="$t('addressName')"
                        v-model.trim="thirdPartyInfo.siteName"
                        v-if="isSaveSoldTo"
                        :rules="[fieldIsRequired('Site name'),  validAddressSiteName(isSaveSoldTo, isSaveFrom, from, isSaveTo, to)]"
                        class="required_field">
                      </v-text-field> 
                    </v-flex>
                  </template>
                </v-layout>
                <template v-if="isThirdParty">
                  <v-layout justify-space-between>
                    <v-flex xs7>
                      <v-layout justify-space-between>
                        <v-flex xs5>
                          <v-text-field
                            hide-details
                            :label="$t('fullName')"
                            v-model.trim="thirdPartyInfo.fullName"
                            :rules="[
                              fieldIsRequired('Full name'), 
                              fieldCharRange('Full name', 3, 35), 
                            ]"
                            class="required_field"
                          />
                        </v-flex>
                        <v-flex xs5>
                          <v-text-field
                            hide-details
                            :label="$t('phone')"
                            :rules="[
                              fieldCharLength('phone', 10)
                            ]"
                            v-model.trim="thirdPartyInfo.phone"
                          />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        hide-details
                        :label="$t('companyName')"
                        v-model.trim="thirdPartyInfo.company"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout justify-space-between>
                    <v-flex xs7>
                      <v-text-field
                        hide-details
                        :label="`${$t('address')} 1`"
                        v-model.trim="thirdPartyInfo.address1"
                        :rules="[fieldIsRequired('Address'), fieldCharLimit('address', 50)]"
                        class="required_field"></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        hide-details
                        :label="`${$t('address')} 2`"
                        :rules="[fieldCharLimit('Address2', 50)]"
                        v-model.trim="thirdPartyInfo.address2"
                        ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-space-between>
                    <v-flex xs7>
                      <v-layout justify-space-between>
                        <v-flex xs5>
                          <v-text-field
                            hide-details
                            :label="$t('city')"
                            v-model.trim="thirdPartyInfo.city"
                            :rules="[fieldIsRequired('City')]"
                            class="required_field"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs5>
                          <vite-autocomplete
                            hide-details
                            :items="states"
                            v-model="thirdPartyInfo.state"
                            :label="$t('state')"
                            :rules="[fieldIsRequired('State')]"
                            class="required_field"
                          >
                            <template v-slot:item="data">
                              <template>
                                <v-list-tile-content>
                                  <v-list-tile-title :id="data.item">
                                    {{data.item}}
                                  </v-list-tile-title>
                                </v-list-tile-content>
                              </template>
                            </template>
                          </vite-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs4>
                      <v-layout justify-space-around align-baseline>
                        <v-flex>
                          <v-text-field
                            hide-details
                            :label="$t('zipCode')"
                            v-model.trim="thirdPartyInfo.zipCode"
                            :rules="[fieldIsRequired('Zip code')]"
                            class="required_field"></v-text-field>    
                        </v-flex>
                        <v-flex xs2>
                          <v-tooltip top>
                            <template v-slot:activator="{on}">
                              <v-btn :disabled="googleMapDisabled" icon flat v-on="on" color="primary" @click.stop="goToGoogleMapLink" small><v-icon>location_on</v-icon></v-btn>
                            </template>
                            <span> {{ $t('googleMap') }}</span>
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                      </v-flex>
                  </v-layout>
                  <v-layout justify-space-between>
                    <v-flex xs7>
                      <v-layout justify-space-between>
                        <v-flex xs5>
                          <v-text-field
                            hide-details
                            :label="$t('email')"
                            v-model.trim="thirdPartyInfo.email"></v-text-field>
                        </v-flex>
                        <v-flex xs5>
                          <vite-autocomplete
                              hide-details
                              :items="fedexTaxTypes"
                              item-text="name"
                              item-value="value"
                              v-model="thirdPartyInfo.taxNumberType"
                              :label="$t('taxNumberType')"
                            ></vite-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs4>
                      <vite-autocomplete
                        hide-details
                        :items="[{
                          name: $t('unitedStates'),
                          value: 'US'
                        }]"
                        item-text="name"
                        item-value="value"
                        v-model="thirdPartyInfo.countryCode"
                        :label="$t('country')"
                        :rules="[v => v !== 'US' && 'must be us']"
                        class="required_field"></vite-autocomplete>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-space-between v-if="thirdPartyInfo.taxNumberType">
                    <v-flex xs7>
                      <v-layout justify-space-between>
                        <v-flex xs5>
                          <v-text-field
                            hide-details
                            :label="$t('taxNumber')"
                            :rules="[fieldIsRequired('taxNumber')]"
                            v-model.trim="thirdPartyInfo.taxNumber"></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </template>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex>
            <v-card width="100%">
              <v-card-text>
                <EeiPackageWidget
                  ref="EeiPackageWidget"
                  :packages.sync="packages"
                  :noteMemoSignature='noteMemoSignature'
                  :shipmentPurpose='shipmentPurpose'
                  :shippingService.sync="shippingService"
                  :bookingConfirmationNumber='bookingConfirmationNumber'
                  :batteryLabel="batteryLabel"
                  :freightCharges="freightCharges"
                  isImportToUS
                  @selectTemplate="selectTemplate"
                />
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row v-if="!!isFedexCarrier">
          <v-flex>
            <v-card width="100%">
              <v-card-text>
                <v-layout class="title" align-baseline justify-space-between style="min-height: 56px;">
                  <v-flex xs1>
                    ETD:
                  </v-flex>
                  <v-flex grow>
                    <v-layout align-center class="etd-checkbox-container">
                      <v-checkbox
                        class="checkbox"
                        v-model="isEnabledETD"
                        :label="$t('ETDLabel')"
                        hide-details>
                      </v-checkbox>
                      <v-tooltip top max-width="300px">
                        <template slot="activator">
                          <v-icon
                            small
                            color="primary"
                            style="cursor: pointer;">
                            help_outline
                          </v-icon>
                        </template>
                        <div style="white-space: normal; line-height: 1.4;">
                          {{ $t('ETDInfo') }}
                        </div>
                      </v-tooltip>
                    </v-layout>
                </v-flex>
                  <v-flex md8 xs8>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row class="compact compact-layout">
          <v-flex>
              <v-card class="compact-card" width="100%">
                <v-card-text class="compact-card-text">
                  <v-layout class="title compact-layout" align-baseline justify-start>
                      {{ $t('commodityInfo') }}:
                    <v-flex xs3 ml-4>
                      <v-layout>
                        <v-flex xs6>
                          <v-combobox
                            hide-details
                            :label="$t('commodityTemplate')"
                            :items="commodityTemplates"
                            item-text="name"
                            item-value="key"
                            clearable
                            @change="onSelectCommodityTemplate"
                          ></v-combobox>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field
                            ref="newTemplateNameInput"
                            hide-details
                            :label="$t('newTemplateName')"
                            v-model.trim="newTemplateName"
                            @keyup.enter="saveCommodityTemplate"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs2>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn icon v-on="on" @click="saveCommodityTemplate" :loading="isSavingTemplate" :disabled="isSavingTemplate">
                                <v-icon>save</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ $t('saveAsTemplate') }}</span>
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex class="red--text font-weight-bold text-xs-right" v-if="commodityErrorMessage">
                      {{ commodityErrorMessage }}
                    </v-flex>
                  </v-layout>
                  <v-data-table
                    :headers="commodityHeaders"
                    :items="commodities"
                    hide-actions
                    class="elevation-2 mt-2"
                  >
                    <template v-slot:headerCell="props">
                      <span v-if="props.header.value === 'action'">
                        <v-tooltip top>
                          <template v-slot:activator="tooltip">
                            <div v-on="tooltip.on">
                              <v-btn color="primary" flat small icon  @click="addEmptyCommodity"><v-icon>add</v-icon></v-btn>
                            </div>
                          </template>
                          {{ $t('add') }}
                        </v-tooltip>
                      </span>
                      <span v-else>{{ props.header.text }}</span>
                    </template>
                    <template v-slot:items="props">
                      <tr
                        class="commodity-row"
                        :class="{'editing': editingRowIndex === props.index}"
                        @click="editRow(props.index, $event)"
                        @mouseleave="onRowMouseLeave"
                      >
                      <td class="text-xs-center">
                        <v-tooltip top>
                          <template v-slot:activator="{on}">
                            <v-btn color="error" flat small icon v-on="on" @click="deleteCommodity(props.index)" :disabled="commodities.length === 1 || isCommodityUnchangeable"><v-icon>delete</v-icon></v-btn>
                          </template>
                          <span>{{ $t('delete') }}</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{on}">
                            <v-btn icon v-on="on" :disabled="props.item.isLoading" :loading="props.item.isLoading" @click="saveCommodityProfile(props.item)">
                              <v-icon color="primary">article</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('saveCommodityTemplate') }}</span>
                        </v-tooltip>
                      </td>
                      <td class="text-xs-left">
                        <v-layout row>
                          <v-autocomplete
                            class="table-item"
                            style="max-width: 200px;"
                            :value="props.item.selectedCommodity"
                            :items="mergedCommoditiesList"
                            item-text="scheduleBDescription"
                            item-value="scheduleBDescription"
                            clearable
                            :label="$t('commodity')"
                            :placeholder="$t('commodities')"
                            @change="onComboboxChangeByCommodities($event, props.index)"
                            @input="onComboboxChangeByCommodities($event, props.index)"
                            :rules="[fieldIsRequired($t('commodity'))]"
                            :disabled="editingRowIndex !== props.index"
                            return-object
                          >
                            <template v-slot:selection="data">
                              {{ data.item.scheduleBDescription || data.item.description }}
                            </template>
                            <template v-slot:item="data">
                              <v-list-tile-content style="max-width: 300px; white-space: normal;">
                                <v-list-tile-title style="white-space: normal; word-wrap: break-word;">{{ data.item.scheduleBDescription || data.item.description }}</v-list-tile-title>
                                <v-list-tile-sub-title style="white-space: normal; word-wrap: break-word;">
                                  Code: {{ data.item.scheduleBCode }}
                                </v-list-tile-sub-title>
                              </v-list-tile-content>
                            </template>
                            <template v-slot:no-data>
                              <v-list-tile>
                                <v-list-tile-content>
                                  <v-list-tile-title>
                                    {{ $t('noDataAvailable') }}
                                  </v-list-tile-title>
                                </v-list-tile-content>
                              </v-list-tile>
                            </template>
                          </v-autocomplete>
                          <v-text-field
                            class="table-item"
                            style="max-width: 250px;"
                            v-model.trim="props.item.scheduleBDescription"
                            :label="$t('description')"
                            :placeholder="$t('description')"
                            :rules="[fieldIsRequired($t('description')), fieldCharLimit('description', 35)]"
                            :disabled="editingRowIndex !== props.index"
                          ></v-text-field>
                        </v-layout>
                      </td>
                      <td class="text-xs-left">
                        <v-layout row>
                        <v-autocomplete
                          class="table-item required_field"
                          v-model="props.item.countryOfOrigin"
                          :items="countryCodeArray"
                          :label="$t('countryOfOrigin')"
                          item-text="name"
                          item-value="value"
                          :rules="[fieldIsRequired($t('countryOfOrigin'))]"
                          :disabled="editingRowIndex !== props.index"
                        ></v-autocomplete>
                          <v-text-field
                          class="table-item required_field"
                          v-model.trim="props.item.harmonizedCode"
                          @input="onHarmonizedCodeInput(props.item)"
                          :rules="[fieldIsRequired('HS Code'), validateHsCode]"
                          :disabled="editingRowIndex !== props.index"
                        ></v-text-field>
                        </v-layout>
                      </td>

                      <td class="text-xs-left">
                        <v-text-field
                          :rules="[
                            fieldIsRequired(),
                            fieldIsInteger(),
                            fieldIsOverZero()
                          ]"
                          class="required_field pt-0 table-item qty_filed"
                          v-model.number="props.item.quantity"
                          @input="onQuantityInput(props.item)"
                          :label="$t('quantity')"
                          :suffix="isUnitValid(props.item) ? getQtySuffix(props.item) : ''"
                          :disabled="editingRowIndex !== props.index"
                          @click.native.stop
                        >
                          <template
                            slot="append-outer"
                            v-if="!isUnitValid(props.item)"
                          >
                            <v-autocomplete
                              class="qty_unit"
                              :items="inShowChannelUnionList"
                              v-model="props.item.selectedUnit"
                              clearable
                              :rules="[fieldIsRequired($t('unit'))]"
                              item-text="text"
                              item-value="key"
                              :label="$t('unit')"
                              :disabled="editingRowIndex !== props.index"
                            ></v-autocomplete>
                          </template>
                        </v-text-field>
                      </td>
                      <td class="text-xs-left">
                        <v-text-field
                          class="table-item required_field"
                          v-model.number="props.item.price"
                          @input="onPriceInput(props.item)"
                          prefix="$"
                          :rules="[fieldIsRequired($t('price')), fieldIsOverZero($t('price')), fieldIsInteger($t('price'))]"
                          :disabled="editingRowIndex !== props.index || isCommodityUnchangeable"
                        ></v-text-field>
                      </td>
                      <td class="text-xs-left">
                        <v-text-field
                          class="table-item required_field"
                          :value="props.item.customsValue"
                          prefix="$"
                          :rules="[fieldIsRequired($t('customsValue')), fieldIsOverZero($t('customsValue'))]"
                          :disabled="true"
                        ></v-text-field>
                      </td>
                      <td class="text-xs-left">
                        <v-text-field
                          class="table-item required_field"
                          v-model.number="props.item.commodityWeight"
                          :suffix="isMeasurementMetric ? 'kg' : 'Lbs'"
                          :rules="[fieldIsRequired($t('totalWeight')), fieldIsOverZero($t('totalWeight'))]"
                          :disabled="editingRowIndex !== props.index"
                        ></v-text-field>
                      </td>
                      </tr>
                    </template>
                  </v-data-table>
                
                </v-card-text>
              </v-card>
          </v-flex>
        </v-layout>
        <v-layout column>
          <v-flex>
            <v-layout justify-end align-baseline>
              <span class="mb-2 font-weight-bold text-xs-right" style="font-size: 16px;background-color: yellow;">
                Rate does not include duties & taxes, clearance entry fees or other import fees.
              </span>
              <v-flex xs7>
                <v-layout align-baseline>
                  <v-flex md2><v-btn color="primary" @click.stop="getRate">{{ $t('getRate') }}</v-btn></v-flex>
                  <v-flex md9>
                    <v-layout>
                      <v-flex md2 v-if="isLoadingRates">
                        <v-progress-circular
                          indeterminate
                          color="primary"></v-progress-circular>
                      </v-flex>
                      <v-flex md10 v-else>
                        <v-layout row no-wrap text-xs-center>
                          {{ $t('baseCharge') }}: $                
                          <v-tooltip top>
                            <template v-slot:activator="tooltip">
                              <span v-on="tooltip.on">
                                {{ displayRate.rate || '----' }}
                              </span>
                            </template>
                            {{displayRate.originBaseCharge ? (Math.round(100*(displayRate.originBaseCharge - displayRate.rate)/displayRate.originBaseCharge)+1) + '% off' : '---'}}
                          </v-tooltip>
                          <span v-if="displayRate.surcharge">
                            &nbsp;&nbsp;
                            {{ $t('surcharge') }}: $ {{ displayRate.surcharge === null ? '----' : displayRate.surcharge }}
                          </span>
                          <small v-if="displayRate.hasResidentialCheck" style="color: blue;">{{
                            $t(displayRate.isResidential ? "residential" : 'commercial')
                          }}</small>
                          <span v-if="displayRate.surcharge">
                            &nbsp;&nbsp;
                            {{ $t('total') }}: $ {{ displayRate.rate ? toMoney(displayRate.rate + displayRate.surcharge) : '----' }}
                          </span>
                          &nbsp;&nbsp;&nbsp;
                          <span v-if="displayRate.estimatedDelivery && displayRate.estimatedDelivery !== 'N/A' && !['xs', 'sm', 'md'].includes($vuetify.breakpoint.name)">
                            {{ $t('estDelivery') }}: {{ formatEstDeliveryDate(displayRate.estimatedDelivery) }}
                          </span>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex md2 v-if="rates.length > 1 && !isLoadingRates" class="subheading font-weight-bold">
                    <!-- more Rates -->
                    <v-menu
                      v-model="moreRatesToggle"
                      :close-on-content-click="false"
                      :nudge-width="200"
                      offset-x
                    >

                      <template v-slot:activator="{ on }">
                        <v-btn
                          dark
                          color="primary"
                          flat
                          v-on="on"
                        > {{ $t('moreRates') }}
                        </v-btn>
                      </template>

                      <v-card>
                        <v-card-text>
                          <v-data-table
                            :headers="[
                              { text: $t('service'), align: 'left', sortable: false, value: 'serviceType' },
                              { text: `${$t('discountCharge')} ($)`, align: 'left', sortable: false, value: 'rate' },
                              { text: `${$t('surcharge')} ($)`, align: 'left', sortable: false, value: 'surcharge'},
                              { text: `${$t('total')} ($)`, align: 'left', sortable: false, value: 'total'},
                              { text: $t('estDelivery'), align: 'left', sortable: false, value: ''}
                            ]"
                            :items="rates"
                            item-key="serviceType"
                            hide-actions
                          >
                            <template v-slot:items="{ item }">
                              <td ><a linkify @click="() => {
                                $refs['EeiPackageWidget'].shippingService = item.serviceType === 'GROUND_HOME_DELIVERY' ? 'FEDEX_GROUND' : item.serviceType
                                
                              }">{{ item.serviceDescription }}</a></td>
                              <td>{{ item.rate }}</td>
                              <td>{{ item.surcharge }}</td>
                              <td>{{ item.total }}</td>
                              <td>
                                {{ formatEstDeliveryDate(item.estimatedDelivery) }}
                              </td>
                            </template>
                          </v-data-table>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" flat @click="moreRatesToggle = false" >Close</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-menu>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout v-if="errorMessage">
              <v-flex class="red--text font-weight-bold text-xs-right">
                {{errorMessage}}
              </v-flex>
            </v-layout>
            <v-layout v-if="Object.keys(warningMessages).length" justify-end>
              <span class="font-weight-bold text-xs-right" style="background-color: yellow;">
                {{Object.values(warningMessages).join(', ')}}
              </span>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </template>
  </FormSubmitPopup>
</template>

<script>
import FormSubmitPopup from './FormSubmitPopup'
import EeiPackageWidget from './EeiPackageWidget'
import { timeTools, checkRules, cloneDeep, toMoney, gotoGoogleMap, measurementTools, calculateQtyMethod, toPickerDateString } from '@/utils/tools'
import ImportUSCommodityWidget from './ImportUSCommodityWidget'
import CommodityWidget from './CommodityWidget'
import LoaderButton from './LoaderButton'
import { mapGetters } from 'vuex'

const addressArr = [
  ['fullName', 'phone', 'company'],
  ['address1', 'address2'],
  ['city', 'state', 'zipCode'],
  ['email', 'countryCode']
]

export default {
  name: 'LabelCreateImportToUsPopup',
  components: {
    FormSubmitPopup,
    EeiPackageWidget,
    ImportUSCommodityWidget,
    CommodityWidget,
    LoaderButton
  },
  mixins: [
    checkRules,
    timeTools,
    measurementTools,
    calculateQtyMethod
  ],
  data () {
    return {
      title: this.$t('createImportToUSLabel'),
      packaging: '',
      signature: '',
      menu: false,
      newSenderName: '',
      to: {
        address1: '', 
        city: '', 
        state: '', 
        zipCode: '',
        countryCode: 'US'
        // taxNumberCountry: 'US'
      },
      fromTemplate: {},
      from: {
        address1: '', 
        city: '', 
        state: '', 
        zipCode: '',
        countryCode: '',
        taxNumberCountry: ''
      },
      toTemplate: {},
      soldToTemplate: {},
      rate: null,
      surcharge: null,
      insuredValue: 0,
      isLoadingRates: false,
      isSaveFrom: false,
      isSaveTo: false,
      isSaveSoldTo: false,
      quantity: 1,
      memo: '',
      note: '',
      errorMessage: '',
      warningMessages: {},
      name: '',
      rates: [],
      moreRatesToggle: false,
      shippingService: '',
      packages: [],
      requestIdCache: '',
      isUseCompanySignatureOnFile: false,
      isOriginatorShipperDiff: false,
      isRecipientNotImporter: false,
      termsOfSale: '',
      isUseCompanyLetterheadOnFile: false,
      isProFormaInvoice: false,
      isCommercialInvoice: true,
      itn: '',
      billingDutiesTaxesFeesTo: 'sender',
      billingTransportationTo: 'sender',
      commodities: [],
      recentItns: [],
      menuItn: false,
      noteMemoSignature: {},
      shipmentPurpose: '',
      bookingConfirmationNumber: '',
      isSupportHazmat: false,
      dangerousGoods: '',
      dryIceDetail: {
        unit: '',
        weight: ''
      },
      batteryLabel: '',
      freightCharges: '',
      isThirdParty: false,
      thirdPartyInfo: {
        countryCode: 'US'
      },
      exportDetail: {},
      isShowFromParseAddress: false,
      parseFormAddress: '',
      isShowToParseAddress: false,
      parseToAddress: '',
      commodityErrorMessage: '',
      newTemplateName: '',
      isSavingTemplate: false,
      editingRowIndex: -1,
      labelNote: '',
      isEeiMode: true,
      isEnabledETD: false,
      notAllowedCountries: [
        'AO',
        'AW',
        'BS',
        'BD',
        'BQ',
        'VG',
        'BN',
        'KH',
        'KY',
        'CW',
        'DJ',
        'DO',
        'TL',
        'EG',
        'SV',
        'GH',
        'GP',
        'GT',
        'HN',
        'JO',
        'KE',
        'KW',
        'LA',
        'LS',
        'MG',
        'MT',
        'MS',
        'AN',
        'NI',
        'OM',
        'PA',
        'BQ',
        'KN',
        'LC',
        'MF',
        'SA',
        'SX',
        'TL',
        'TT',
        'TC',
        'VI',
        'AE'
      ]
    }
  },
  async created () {
    this.recentItns = [...(await this.$store.dispatch('getRecentItns')), {
      itn: 'NO EEI 30.36'
    }, {
      itn: 'NO EEI 30.37 (a)'
    }]

    try {
      if (!this.commodityTemplates || this.commodityTemplates.length === 0) {
        this.$store.dispatch('getCommodityTemplates')
      }
    } catch (error) {
      console.error('Failed to fetch commodity templates:', error)
    }
  },
  computed: {
    ...mapGetters(['commodityTemplates']),
    cedFilings () {
      return [
        {'label': 'Not required', 'value': 'NOT_REQUIRED'},
        {'label': 'Manually attached', 'value': 'MANUALLY_ATTACHED'},
        {'label': 'Filed electronically', 'value': 'FILED_ELECTRONICALLY'},
        {'label': 'Summary reporting', 'value': 'SUMMARY_REPORTING'},
        {'label': 'Fedex to stamp', 'value': 'FEDEX_TO_STAMP'}
      ]
    },
    exemptionNumbers () {
      return ['01', '02', '03', '04', '05', '06']
    },
    isDHL () {
      return this.currentShippingService?.carrier?.toLowerCase() === 'dhl'
    },
    isFEDEX () {
      return this.currentShippingService?.carrier?.toLowerCase() === 'fedex-import-international'
    },
    isFedexCarrier () {
      if (!this.currentShippingService?.carrier) return false
      return this.currentShippingService.carrier.toUpperCase().includes('FEDEX')
    },
    allowedCountries () {
      return this.currentShippingService?.allowedCountries || []
    },
    allowedCountriesItems () {
      return this.allowedCountries.map(item => ({
        name: this.countryCodeArrayMap[item],
        value: item
      }))
    },
    countryCodeArrayMap () {
      return (this.$store.getters.countryCodeArray || []).reduce((obj, item) => {
        obj[item.value] = item.name
        return obj
      }, {})
    },
    currentShippingService () {
      return this.importToUSLabelServices.find(service => 
        service.serviceTypes.some(serviceType => this.shippingService === serviceType.value)
      ) || {}
    },
    fromStates () {
      return Object.values(this.countryStatesMap[this.from.countryCode] || {})
    },
    countryStatesMap () {
      return this.$store.getters.countryStatesMap
    },
    fromTaxNumberTypes () {
      const typesMap = {
        EIN: 'Employer Identification Number',
        VAT: 'VAT Registration (VAT / GST)',
        DAN: 'Deferment Account Duties Only',
        DTF: 'Deferment Account Duties, Taxes and Fees Only',
        TAN: 'Deferment Account Tax Only',
        DUN: 'Data Universal Numbering System',
        EOR: 'Economic Operator Registration ID',
        FED: 'Federal Tax ID',
        FTZ: 'Free Trade Zone ID',
        SSN: 'Social Security Number',
        STA: 'State Tax ID',
        CNP: 'Brazil CNPJ/CPF Federal Tax'
      }
      const types = Object.entries(typesMap).map(([value, name]) => ({
        name: `${name}(${value})`,
        value
      }))
      return [{ name: this.$t('none'), value: '' }, ...types]
    },
    isCommodityUnchangeable () {
      return false
    },
    toTaxNumberTypes () {
      const typesMap = {
        EIN: 'Employer Identification Number',
        VAT: 'VAT Registration (VAT / GST)',
        EOR: 'Economic Operator Registration ID',
        SDT: 'IOSS Import One-Stop-Shop'
      }
      const types = Object.entries(typesMap).map(([value, name]) => ({
        name: `${name}(${value})`,
        value
      }))
      return [{ name: this.$t('none'), value: '' }, ...types]
    },
    fedexTaxTypes () {
      return [
        'PERSONAL_NATIONAL',
        'PERSONAL_STATE',
        'FEDERAL',
        'BUSINESS_NATIONAL',
        'BUSINESS_STATE',
        'BUSINESS_UNION'
      ].map(item => { 
        const formatName = item.replace(/_/g, ' ')
        const otherName = formatName.slice(1).toLocaleLowerCase()
        return { 
          name: formatName[0] + otherName, 
          value: item 
        }
      }).concat({ name: 'NONE', value: '' })
    },
    scheduleBMap () {
      return this.$store.getters.scheduleBMap
    },
    isSupportDangerousGoods: {
      get () {
        return !!(this.hasHazmatFeatures && this.dangerousGoods)
      },
      set (value) {
        this.isSupportHazmat = !!value
      }
    },
    hasHazmatFeatures () {
      return this.visibleBetaFeatures.includes('InternationalHazmat')
    },
    fromAddress () {
      const addresses = this.addresses
      return addresses
    },
    // hazmatSites () {
    //   return this.$store.getters.hazmatSites
    // },
    visibleBetaFeatures () {
      return this.$store.getters.visibleBetaFeatures
    },
    states () {
      return this.$store.getters.stateAbbrevs
    },
    addresses () {
      return this.$store.getters.tenantAddresses
    },
    packagingMap () {
      return this.$store.getters.packagingMap
    },
    importToUSLabelServices () {
      return this.$store.getters.importToUSLabelServices
    },
    systemBalance () {
      return this.$store.getters.systemBalance
    },
    displayRate () {
      return this.rates.find(({serviceType = '', carrier = ''}) => 
        carrier.toLowerCase() === this.shippingService.toLowerCase() || 
        serviceType.toLowerCase() === this.shippingService.toLowerCase() || 
        (this.shippingService === 'FEDEX_GROUND' && serviceType === 'GROUND_HOME_DELIVERY')
      ) || {}
    },
    limitMultipleShipping () {
      if (this.packages.reduce((acc, pkg) => acc + pkg.qty, 0) === 1) return (v) => v <= 5 || this.$t('limitedLabelNum', { num: 5 })
      if (this.shippingService !== 'USPS') {
        return (v) => v <= 1 || this.$t('multipleShippingAreOnlySupportedForUsps')
      }
      return (v) => v <= 5 || this.$t('limitedLabelNum', { num: 5 })
    },
    isMeasurementMetric () {
      return !!this.$store.getters.isMeasurementMetric
    },
    googleMapDisabled () {
      return !(
        this.to && (
          this.to.address1 &&
          this.to.city &&
          this.to.state &&
          this.to.zipCode
        )
      )
    },
    countryCodeArray () {
      return this.$store.getters.countryCodeArray
    },
    commodityHeaders () {
      const totalCustomsValue = this.commodities.reduce((acc, item) => acc + (item.customsValue || 0), 0)
      const totalQty = this.commodities.reduce((acc, item) => acc + (item.quantity || 0), 0)
      const totalWeight = this.commodities.reduce((acc, item) => acc + (item.commodityWeight || item.weight || 0), 0)
      
      return [
        { text: this.$t('actions'), value: 'action', align: 'center', sortable: false, width: '80px' },
        { text: this.$t('commodity'), value: 'scheduleBDescription', align: 'left', sortable: false, width: '280px' },
        { text: `${this.$t('countryOfOrigin')} / ${this.$t('hsCode')}`, value: 'harmonizedCode', align: 'left', sortable: false, width: '200px' },
        { text: `${this.$t('qty')}(${totalQty})`, value: 'quantity', align: 'left', sortable: false, width: '150px' },
        { text: `${this.$t('price')}`, value: 'price', align: 'left', sortable: false, width: '90px' },
        { text: `${this.$t('customsValue')}($${totalCustomsValue.toLocaleString()})`, value: 'customsValue', align: 'left', sortable: false, width: '120px' },
        { text: `${this.$t('totalWeight')}(${this.isMeasurementMetric ? 'kg' : 'Lbs'})(${totalWeight})`, value: 'commodityWeight', align: 'left', sortable: false, width: '120px' }
      ]
    },
    mergedCommoditiesList () {
      const customOption = {
        scheduleBDescription: 'Commodity Desc',
        description: 'Commodity Desc',
        scheduleBCode: '',
        harmonizedCode: '',
        countryOfOrigin: 'US',
        _isCustom: true
      }
      const list = this.organizationCommodities.map(item => ({
        ...item,
        scheduleBDescription: item.description || item.scheduleBDescription || '',
        harmonizedCode: item.scheduleBCode
      }))
      return [customOption, ...list]
    },
    isScheduleBReady () {
      return !!this.scheduleBMap['0101210000']
    },
    commonCommodities () {
      return this.$store.getters.commonCommodities || []
    },
    organizationCommodities () {
      return this.$store.getters.organizationCommodities || []
    },
    countryOfOriginList () {
      return [{
        name: this.$t('domesticOrigin'),
        value: 'D'
      }, {
        name: this.$t('foreignOrigin'),
        value: 'F'
      }]
    },
    inShowChannelUnionList () {
      return this.carrierItems || []
    },
    inShowUnit2List () {
      return this.carrierItems || []
    },
    carrierItems () {
      return [{
        text: 'PCS',
        key: 'PCS'
      }, {
        text: 'KG',
        key: 'KG'
      }, {
        text: 'LB',
        key: 'LB'
      }]
    },
    labelTemplates () {
      return (this.$store.getters.labelTemplates || []).filter(item => item.businessType === this.businessType)
    }
  },
  beforeMount () {
    const {shippingService, shipmentPurpose, note, memo, signature, bookingConfirmationNumber, batteryLabel, freightCharges, exportDetail, thirdParty, isThirdParty} = this.labelInfo
    if (shippingService) {
      let actualService = ''
      for (const service of this.importToUSLabelServices) {
        const serviceType = service.serviceTypes.find(serviceType => shippingService === serviceType.value)
        if (serviceType) {
          actualService = serviceType.value
          break
        }
      }
      if (actualService) {
        this.shippingService = actualService
      }
    }
    if (shipmentPurpose) this.shipmentPurpose = shipmentPurpose
    if (bookingConfirmationNumber) this.bookingConfirmationNumber = bookingConfirmationNumber
    if (batteryLabel) this.batteryLabel = batteryLabel
    if (freightCharges) this.freightCharges = freightCharges
    if (exportDetail) this.exportDetail = exportDetail
    if (isThirdParty) this.isThirdParty = isThirdParty
    if (thirdParty) {
      this.thirdPartyInfo = thirdParty || {}
      this.isThirdParty = !!Object.keys(this.thirdPartyInfo).length
    }
    if (note || memo || signature) Object.assign(this.noteMemoSignature, {note, memo, signature})
    
    // 获取 Schedule B 数据
    if (!this.scheduleBMap['0101210000'] && Object.keys(this.$store.getters.scheduleBMap || {}).length === 0) {
      this.$store.dispatch('getAESHTS').catch(error => {
        this.$store.dispatch('showToast', {
          level: 'error',
          info: this.$t('networkError')
        })
        throw error
      })
    }
    
    // 获取组织商品数据
    if (this.$store.getters.organizationCommodities.length === 0) {
      this.$store.dispatch('getOrganizationCommodities')
    }
  },
  mounted () {
    if ((this.labelInfo.packages && this.labelInfo.packages.length) || (this.labelInfo.commodities && this.labelInfo.commodities.length)) {
      const { dangerousGoodsInfo, commodities = [], ...infos } = this.labelInfo
      Object.assign(this, infos)
      if (commodities.length) {
        this.commodities = commodities.map(item => {
          item.commodityWeight = item.commodityWeight || item.weight
          return item
        })
      }
      this.isSupportHazmat && Object.assign(this, dangerousGoodsInfo)
      this.packages = this.calAndAddQtyfromHistoryPkgs(this.packages)
    } else {
      this.applyDefaultLabelTemplate()
    }
    if (this.commodities.length === 0) {
      this.addEmptyCommodity()
    }
  },
  watch: {
    toTemplate (value) {
      const to = cloneDeep(this.toTemplate)
      to.countryCode = 'US'
      this.to = to
    },
    fromTemplate (value) {
      this.from = cloneDeep(this.fromTemplate)
    },
    soldToTemplate (value) {
      this.thirdPartyInfo = Object.assign(this.thirdPartyInfo, cloneDeep(value))
    },
    shippingService (value) {
      if (['USPS', 'UPS_GROUND'].includes(value)) {
        this.quantity = 1
        this.packages && this.packages.forEach(pkg => {
          pkg.insuredValue = 0
        })
      }
    },
    parseFormAddress (value) {
      if (!value) {
        return
      }
      const lineData = value.split(/\n|\t/)
      addressArr.forEach((items, index) => {
        const data = lineData[index]?.split(',') || []
        items.forEach((item, i) => {
          let target = data[i]
          if (!target) return
          if (['state', 'countryCode'].includes(item)) target = target?.toUpperCase() || ''
          this.from[item] = target?.trim() || ''
        })
      })
    },
    parseToAddress (value) {
      if (!value) {
        return
      }
      const lineData = value.split(/\n|\t/)
      addressArr.forEach((items, index) => {
        const data = lineData[index]?.split(',') || []
        items.forEach((item, i) => {
          let target = data[i]
          if (!target) return
          if (['state', 'countryCode'].includes(item)) target = target?.toUpperCase() || ''
          this.to[item] = target?.trim() || ''
        })
      })
    }
  },
  methods: {
    applyLabelTemplate (template) {
      if (!template) return
      if (template.from && Object.keys(template.from).length) this.from = cloneDeep(template.from)
      if (template.to && Object.keys(template.to).length) this.to = cloneDeep(template.to)
      this.selectTemplate(template)
      this.$nextTick(() => {
        const widget = this.$refs['EeiPackageWidget']
        if (widget && widget.onSelectTemplate) {
          widget.onSelectTemplate(template)
          if (template.shipDate) {
            widget.shipDate = toPickerDateString(new Date(template.shipDate))
          }
        }
      })
      if (template.commodities && Array.isArray(template.commodities) && template.commodities.length) {
        this.commodities = template.commodities.map(item => {
          item.commodityWeight = item.commodityWeight || item.weight
          return item
        })
      }
    },
    applyDefaultLabelTemplate () {
      const defaultTemplate = this.$store.getters.defaultLabelTemplateByType(this.businessType)
      if (defaultTemplate) this.applyLabelTemplate(defaultTemplate)
    },
    toCeilInt (value) {
      if (isNaN(value)) return 0
      return parseInt(Math.ceil(value))
    },
    onQuantityInput (item) {
      item.customsValue = this.computeCustomsValue(item)
    },
    onPriceInput (item) {
      item.customsValue = this.computeCustomsValue(item)
    },
    computeCustomsValue (item) {
      if (!item.price || !item.quantity) return 0
      if (isNaN(item.price) || isNaN(item.quantity)) return 0
      return this.toCeilInt(Number(item.price * item.quantity))
    },
    toggleParseAddress (name, textName, addressInfo) {
      const value = this[name]
      if (!value) {
        this[name] = true
        let address = ''
        addressArr.forEach(items => {
          items.forEach((item, index) => {
            if (address && ![items.length, 0].includes(index)) address += ','
            address += addressInfo[item] || ''
          })
          address += '\n'
        })
        if (!address.replace(/,/g, '').trim()) return
        this[textName] = address
      } else {
        this[name] = false
      }
    },
    validAddressSiteName (isSaveTarget, isSave, addressInfo, isOtherSave, otherAddressInfo) {
      return v => {
        return (
          (isSave && isSaveTarget && v === addressInfo.siteName) || 
          (isOtherSave && isSaveTarget && v === otherAddressInfo.siteName)
        ) ? this.$t('existSameSiteName') : true
      }
    },
    getUnitOfMeasure (scheduleBCode = '', carrier = '') {
      let unitOfMeasure = ''
      carrier = carrier.trim().toUpperCase()
      const matchedItem = this.scheduleBMap[scheduleBCode]
      if (!matchedItem) return unitOfMeasure
      if (this.isEeiMode) return matchedItem.uom
      
      if (matchedItem.uom === 'NO') {
        unitOfMeasure = (carrier.includes('UPS') && 'PCS') || (carrier.includes('FEDEX') && 'NO') || matchedItem.uom
      } else {
        unitOfMeasure = matchedItem.uom
      }
      return unitOfMeasure
    },
    selectTemplate (e) {
      const {
        dangerousGoods,
        dryIceDetail = {}
      } = e
      const params = {
        dangerousGoods,
        dryIceDetail
      }
      Object.assign(this, params)
      if (e.shipDate && this.$refs['EeiPackageWidget']) {
        this.$refs['EeiPackageWidget'].shipDate = e.shipDate
      }
    },
    clearFromTemplate (value) {
      // reset from
      if (!value) return 
      this.fromTemplate = {}
    },
    toMoney,
    async getAddressFromItn () {
      const {from = {}, to = {}, commodities = [], onboardDate} = await this.$store.dispatch('getAddressFromItn', {itn: this.itn})
      if (onboardDate) {
        Object.assign(this, {from, to, commodities})
        this.$refs['EeiPackageWidget'].shipDate = onboardDate
      }
    },
    createAddress (addresses) {
      return this.$store.dispatch('labelCreateAddress', {addresses})
    },
    extractPayload () {
      const {
        from,
        to,
        commodities = []
      } = this

      const {
        packages,
        shipDate, 
        shippingService,
        signature,
        memo,
        note,
        purpose = '',
        carrier,
        bookingConfirmationNumber,
        batteryLabel = '',
        freightCharges = ''
      } = this.$refs['EeiPackageWidget'].$$extractData()

      const [serviceType = '', channel = ''] = (shippingService || '').split(' - ')

      let {name, taxNumber, taxNumberCountry, ...fromRest} = from
      const actualFrom = from.taxNumberType 
        ? { ...fromRest, taxNumber, taxNumberCountry } 
        : fromRest

      let {
        address1, 
        address2, 
        taxesPaidAmount: toTaxesPaidAmount, 
        taxNumberCountry: toTaxNumberCountry,
        taxNumber: toTaxNumber,
        ...rest
      } = to
      const actualTo = to.taxNumberType 
        ? {
          ...rest,
          address1,
          address2: address2 || '',
          taxNumber: toTaxNumber,
          taxNumberCountry: toTaxNumberCountry,
          taxesPaidAmount: toTaxesPaidAmount
        }
        : {
          ...rest,
          address1,
          address2: address2 || ''
        }
      this.validDangerousGoodsInfo()

      if (!this.currentShippingService.isSupportFromExt) {
        delete actualFrom.extension
      }
      if (!this.currentShippingService.isSupportToExt) {
        delete actualTo.extension
      }
      const payload = {
        packages,
        from: actualFrom,
        to: actualTo,
        shipDate,
        serviceType,
        channel,
        shippingService,
        signature,
        memo,
        note: note || this.labelNote,
        carrier,
        isMeasurementMetric: this.isMeasurementMetric,
        commodities: commodities.map(item => {
          const {commodityWeight, selectedCommodity, isLoading, weight, ...rest} = item
          item.unitOfMeasure = rest.quantityUnits
          return {weight: commodityWeight, ...rest}
        }),
        bookingConfirmationNumber,
        purpose
        // isSupportHazmat: isSupportDangerousGoods,
        // carriers
      }
      if (this.isDHL) {
        Object.assign(payload, {
          tradeTerms: 'DDU',
          isBattery: !!batteryLabel,
          batteryLabel: batteryLabel || '',
          freightCharges: freightCharges || 0
        })
      } else if (this.isFEDEX) {
        if (packages.some(pkg => pkg.declaredValue > 0) && ['', 'NO_SIGNATURE_REQUIRED'].includes(signature)) {
          throw Error('Insurance requires select signature')
        } 
        if (from.countryCode === 'CA') {
          Object.assign(payload, {
            exportDetail: this.exportDetail
          })
        }
        if (this.isThirdParty) {
          Object.assign(payload, {
            thirdParty: this.thirdPartyInfo
          })
        }
      }
      return payload
    },
    getRate () {
      this.rates = []
      if (this.packages.reduce((acc, pkg) => acc + pkg.qty, 0) > 99) {
        throw Error('Package quantity are limited to 99.')
      }
      try {
        this.moreRates = []
        if (!this.$refs['formPopup'].validate()) return
        this.errorMessage = ''
        this.deleteWarningMessage('address-ambiguous', 'recommend-address')
        let payload = this.extractPayload()
        this.systemBalance.discount && (payload.discount = this.systemBalance.discount)
        this.isLoadingRates = true
        this.$store.dispatch('getRates', payload)
          .then(rtn => {
            if (rtn.data.notMatch) {
              this.setWarningMessages('address-ambiguous', this.$t('notMatch'))
            } else if (rtn.data.isCleansed) {
              let {
                address1,
                city,
                state,
                zipCode
              } = rtn.data
              this.setWarningMessages('recommend-address', this.$t('recommendedRecipientAddress', { address: address1, city, state, zipCode }))
            } 
            if (rtn.data.moreRates) {
              const {estimatedDelivery: estDelivery = null} = rtn.data
              this.rates = rtn.data.moreRates.map(({serviceType, serviceDescription, amountDetails, estimatedDelivery = estDelivery, originBaseCharge}) => {
                const {postageAmount, ...surcharges} = amountDetails
                const surcharge = Object.values(surcharges).reduce((a, b) => toMoney(a + b), 0)
                return {
                  carrier: rtn.data.carrier,
                  serviceType,
                  serviceDescription,
                  rate: postageAmount,
                  hasResidentialCheck: true,
                  isResidential: rtn.data.isResidential,
                  surcharge,
                  total: toMoney(surcharge + postageAmount),
                  estimatedDelivery,
                  originBaseCharge: originBaseCharge && Number(originBaseCharge)
                }
              })
            } else if (rtn.data.totalAmount) { // non-fedex
              const {postageAmount, ...surcharges} = rtn.data.amountDetails
              const surcharge = Object.values(surcharges).reduce((a, b) => toMoney(a + b), 0)
              const {carrier = 'usps', serviceType, serviceDescription, estimatedDelivery, originBaseCharge} = rtn.data
              this.rates = [{
                carrier,
                serviceType,
                serviceDescription,
                estimatedDelivery,
                hasResidentialCheck: false,
                rate: postageAmount,
                surcharge,
                originBaseCharge: originBaseCharge && Number(originBaseCharge),
                total: toMoney(surcharge + postageAmount)
              }]
            }
          })
          .catch(error => {
            this.errorMessage = error.message
          })
          .finally(() => {
            this.isLoadingRates = false
          })
      } catch (e) {
        this.errorMessage = e.message
      }
    },
    getQtySuffix (item) {
      if (!this.scheduleBMap[item.scheduleBCode]) return ''
      const unit = this.getUnitOfMeasure(item.scheduleBCode, this.currentShippingService.carrier)
      return this.inShowChannelUnionList.find(item => item.key === unit)?.key || unit
    },
    isUnitValid (item) {
      const unit = this.getQtySuffix(item)
      return unit && this.inShowChannelUnionList.find(item => item.key === unit)
    },
    validateHsCode (value) {
      if (!value) return true
      
      if (value.length < 6 || value.length > 15 || isNaN(+value)) {
        return this.$t('hsCodeValidation')
      }
      
      if (this.currentShippingService && 
          this.currentShippingService.carrier && 
          this.currentShippingService.carrier.toUpperCase().includes('FEDEX')) {
        if (value.length < 6) {
          return this.$t('fedexRequires6DigitHsCode')
        }
      }
      
      return true
    },
    onSubmitted () {
      const pkgQty = this.packages.reduce((acc, pkg) => acc + pkg.qty, 0)
      if (pkgQty > 99) {
        throw Error('Package quantity are limited to 99.')
      }

      const payload = this.extractPayload()
      if (!this.order) {
        delete payload.orderKey
      }
      let {isSaveFrom, isSaveTo, isSaveSoldTo, to, from, thirdPartyInfo} = this
      let {isAmazon: tempFlag, ...toRest} = to
      let {isAmazon, ...fromRest} = from
      let {isAmazon: soldToTempFlag, ...soldToRest} = thirdPartyInfo
      let addressesToCreate = []
      isSaveTo && addressesToCreate.push(toRest)
      isSaveFrom && addressesToCreate.push(fromRest)
      isSaveSoldTo && addressesToCreate.push(soldToRest)
      addressesToCreate.length && this.createAddress(addressesToCreate)
      this.errorMessage = ''
      const label = {
        ...payload,
        isMeasurementMetric: this.isMeasurementMetric,
        requestId: this.requestIdCache || this.idGenerator(1)[0]
      }
      if (this.isEnabledETD && this.isFedexCarrier) {
        label.isEnabledETD = true
        const country = String(this.to.countryCode || '').trim().toUpperCase()
        if (this.notAllowedCountries.includes(country)) {
          throw Error(this.$t('etdCountryNotSupported', { country }))
        }
      }
      return this.$store.dispatch('createInternationalLabel', label)
        .then(rtn => {
          this.requestIdCache = ''
          const {successLabels, errorLabels} = rtn
          this.$emit('submitted', successLabels
            .map(item => {
              return {
                ...item,
                createTime: new Date(),
                lastModifiedTime: new Date()
              }
            }))
          if (errorLabels.length > 0) {
            throw Error(errorLabels[0].message || `${successLabels.length} label(s) created successfully. ${errorLabels.length} failed. You can try recreating the rest of labels.`)
          }
        })
        .catch(error => {
          if (error.message === 'request-label-error') {
            this.errorMessage = this.$t('failedToRequestForLabel')
          } else if (error.message === 'endpoint-request-timed-out') {
            this.errorMessage = this.$t('labelEndpointRequestTimedOut')
            this.requestIdCache = label.requestId
          } else if (error.message === 'Package 1 - Special service SIGNATURE_OPTION is invalid.') {
            this.errorMessage = this.$t('specialServiceInvalid')
          } else {
            this.errorMessage = error.data ? error.data.message : error.message
          }
          throw new Error(this.errorMessage)
        })
    },
    onHarmonizedCodeInput (item) {
      item.harmonizedCode = item.harmonizedCode
      item.scheduleBCode = item.harmonizedCode
    },
    deleteAddress (address) {
      if (!confirm(this.$t('confirmDelete', { name: 'address' }))) return Promise.resolve()
      return this.$store.dispatch('labelDeleteAddress', address)
        .then(() => {
          if (this.from.siteName === address.siteName) {
            this.from = {}
          }
          if (this.to.siteName === address.siteName) {
            this.to = {}
          }
        })
    },
    setWarningMessages (key, value) {
      this.warningMessages[key] = value
    },
    deleteWarningMessage (...keys) {
      keys.forEach(key => {
        delete this.warningMessages[key]
      })
    },
    clearWarningMessages () {
      this.warningMessages = {}
    },
    formatEstDeliveryDate (str) {
      return (str === 'N/A' || !str) ? 'N/A' : this.toDateYYYYMMDD((new Date(str)))
    },
    goToGoogleMapLink () {
      gotoGoogleMap(this.to)
    },
    onSelectItn (item) {
      this.itn = item.itn
      this.menuItn = false
    },
    async getEeiStatus () {
      await Promise.all(this.recentItns.map(async item => {
        if (item.itn) return 'success'
        const {itn} = await this.$store.dispatch('getEeiStatus', item)
        item.itn = itn
      }))
      return 'success'
    },
    validDangerousGoodsInfo () {
      const { 
        isSupportDangerousGoods, 
        packages,
        shippingService,
        importToUSLabelServices
      } = this
      if (!isSupportDangerousGoods) return
      const isPackageGreaterThanTwo = packages.length === 1 
        ? packages[0].qty === 1
        : false
      if (!isPackageGreaterThanTwo) throw Error(this.$t('hazmatPackageError'))

      const isSupportHazmatService = importToUSLabelServices.some(service => {
        const serviceType = service.serviceTypes.find(serviceType => shippingService === serviceType.value)
        return serviceType && serviceType.isSupportDangerousGoods
      })
      if (!isSupportHazmatService) throw Error(this.$t('shippingServiceNotSupportDangerousGoods'))
    },
    addEmptyCommodity () {
      this.commodities.push({
        scheduleBDescription: '',
        scheduleBCode: '',
        countryOfOrigin: '',
        quantity: 1,
        price: 0,
        quantityUnits: 'PCS',
        quantity2: 0,
        quantity2Units: 'PCS',
        customsValue: 0,
        commodityWeight: 0,
        isLoading: false,
        selectedCommodity: null
      })
      this.editingRowIndex = this.commodities.length - 1
    },
    editRow (index, event) {
      if (this.editingRowIndex === index) return
      
      this.editingRowIndex = index
      
      if (event) event.stopPropagation()
    },
    onRowMouseLeave (event) {
      if (event && event.relatedTarget) {
        if (event.currentTarget.contains(event.relatedTarget)) {
          return
        }
        const selectMenus = document.querySelectorAll('.v-select-list, .v-menu__content')
        for (let menu of selectMenus) {
          if (menu.contains(event.relatedTarget)) {
            return
          }
        }
      }
      setTimeout(() => {
        const activeElement = document.activeElement
        if (activeElement && (
          activeElement.closest('.qty_unit') || 
          activeElement.closest('.v-select-list') ||
          activeElement.closest('.v-menu__content')
        )) {
          return
        }
        this.editingRowIndex = -1
      }, 100)
    },
    async saveCommodityProfile (item) {
      item.isLoading = true
      try {
        this.$store.dispatch('showToast', {
          level: 'success',
          info: 'Commodity profile saved successfully'
        })
      } catch (error) {
        this.commodityErrorMessage = error.message
      } finally {
        item.isLoading = false
      }
    },
    async onSelectCommonCommodity (data) {
      if (!data) return
      
      const selectedItem = typeof data === 'string' 
        ? this.commonCommodities.find(item => item.description === data) 
        : data
      
      if (selectedItem) {
        const newCommodity = {
          scheduleBDescription: selectedItem.description,
          scheduleBCode: selectedItem.code || '',
          countryOfOrigin: 'D',
          quantity: 1,
          price: 0,
          quantityUnits: 'PCS',
          quantity2: 0,
          quantity2Units: 'PCS',
          customsValue: 0,
          commodityWeight: 0,
          isLoading: false
        }
        
        this.commodities.push(newCommodity)
        this.editingRowIndex = this.commodities.length - 1
      }
    },
    onComboboxChange (value, index) {
      const item = this.commodities[index]
      if (value && typeof value === 'object') {
        item.scheduleBDescription = value.scheduleBDescription || value.description || ''
        item.scheduleBCode = value.scheduleBCode || ''
        item.countryOfOrigin = 'D'
      } else if (value && typeof value === 'string') {
        item.scheduleBDescription = value
        item.scheduleBCode = ''
        item.countryOfOrigin = 'D'
      } else {
        item.scheduleBDescription = ''
        item.scheduleBCode = ''
        item.countryOfOrigin = ''
      }
    },
    onSelectCommodityTemplate (template) {
      if (!template) return

      const templateData = typeof template === 'string'
        ? this.commodityTemplates.find(item => item.name === template)
        : template

      if (templateData && templateData.commodities && templateData.commodities.length > 0) {
        this.commodities = templateData.commodities.map(item => {
          const matchedCommodity = this.mergedCommoditiesList.find(c => c.scheduleBCode === item.scheduleBCode)
          return {
            ...item,
            selectedCommodity: matchedCommodity || this.mergedCommoditiesList.find(c => c._isCustom),
            customsValue: (item.quantity || 0) * (item.price || 0)
          }
        })
      }
    },
    saveCommodityTemplate () {
      const templateName = this.newTemplateName

      if (!templateName || !templateName.trim()) {
        this.$store.dispatch('showToast', {info: this.$t('pleaseEnterTemplateName'), level: 'error'})
        return
      }

      const trimmedName = templateName.trim()

      const isDuplicate = this.commodityTemplates.some(template => template.name === trimmedName)
      if (isDuplicate) {
        this.$store.dispatch('showToast', {info: this.$t('templateNameAlreadyExists'), level: 'error'})
        return
      }

      if (!this.commodities || this.commodities.length === 0) {
        this.$store.dispatch('showToast', {info: this.$t('pleaseAddCommoditiesFirst'), level: 'error'})
        return
      }

      this.isSavingTemplate = true

      const payload = {
        name: trimmedName,
        description: trimmedName,
        commodities: this.commodities.map(item => ({
          scheduleBCode: item.scheduleBCode || '',
          scheduleBDescription: item.scheduleBDescription || '',
          harmonizedCode: item.harmonizedCode || '',
          countryOfOrigin: item.countryOfOrigin || 'US',
          quantity: item.quantity || 0,
          selectedUnit: item.selectedUnit || item.unitOfMeasure || '',
          quantity2: null,
          quantity2Units: '',
          price: item.price || 0,
          customsValue: item.customsValue || 0,
          commodityWeight: item.commodityWeight || 0
        }))
      }

      this.$store.dispatch('updateCommodityTemplate', payload).then(() => {
        this.$store.dispatch('showToast', {info: this.$t('templateSavedSuccessfully'), level: 'success'})
        this.newTemplateName = ''
      }).catch(error => {
        this.$store.dispatch('showToast', {info: error.message || this.$t('failedToSaveTemplate'), level: 'error'})
        throw error
      }).finally(() => {
        this.isSavingTemplate = false
      })
    },
    deleteCommodity (index) {
      if (this.commodities.length === 1) {
        this.commodityErrorMessage = 'Cannot delete the last commodity'
        return
      }
      this.commodities.splice(index, 1)
      this.editingRowIndex = -1
    },
    onComboboxChangeByCommodities (selectedItem, index) {
      this.commodityErrorMessage = ''
      if (this.isCommodityUnchangeable && selectedItem) {
        this.commodities[index].harmonizedCode = selectedItem.scheduleBCode || ''
        this.commodities[index].countryOfOrigin = selectedItem.countryOfOrigin || 'US'
        this.commodities[index].scheduleBDescription = selectedItem.scheduleBDescription || ''
        this.commodities[index].price = 0
        this.commodities[index].unitOfMeasure = selectedItem.unitOfMeasure || this.getUnitOfMeasure(selectedItem.harmonizedCode, this.currentShippingService.carrier)
        return
      }
      
      if (selectedItem === null || selectedItem === '') {
        this.commodities[index].harmonizedCode = ''
        this.commodities[index].selectedCommodity = null
        this.commodities[index].scheduleBCode = ''
        this.commodities[index].exportInformationCode = 'OS'
        this.commodities[index].countryOfOrigin = 'US'
        this.commodities[index].licenseExceptionSymbol = 'C33'
        this.commodities[index].price = 0
        return
      }
      
      if (typeof selectedItem === 'object') {
        const {
          scheduleBDescription, 
          description,
          harmonizedCode, 
          scheduleBCode
        } = selectedItem
        this.commodities[index].scheduleBDescription = scheduleBDescription || description || ''
        this.commodities[index].harmonizedCode = harmonizedCode || scheduleBCode || ''
        this.commodities[index].scheduleBCode = ''
        this.commodities[index].selectedCommodity = selectedItem
        this.commodities[index].countryOfOrigin = selectedItem.countryOfOrigin || 'US'
      } else if (typeof selectedItem === 'string' && selectedItem.trim() !== '') {
        this.commodities[index].scheduleBDescription = selectedItem
        this.commodities[index].selectedCommodity = null
      }
    }
  },
  props: {
    value: Boolean,
    idGenerator: Function,
    initTemplate: {
      type: Object,
      default: () => {
        return {}
      }
    },
    onlyOneLabel: Boolean,
    order: Object,
    labelInfo: Object,
    businessType: {
      type: String,
      default: 'import'
    }
  }
}
</script>

<style scoped>

.checkbox {
  margin-bottom: 0px; 
  position: relative; 
  top: 12px;
}

.thirdPartySold {
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 0;
  transform: translateY(5px);
}

.commodity-row {
  cursor: pointer;
  transition: all 0.2s;
}

.compact-card-text {
  padding: 8px 16px !important;
}

.compact-layout {
  margin-top: 2px !important;
  margin-bottom: 2px !important;
}

.table-item {
  margin: 4px !important;
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}

.compact {
  padding: 4px !important;
  zoom: 0.8;
  margin-bottom: 12px !important;
}

.compact .v-container {
  padding: 4px !important;
}

.compact .v-card {
  margin-bottom: 4px !important;
}

.compact .v-card__text {
  padding: 8px 16px !important;
}

.compact .v-layout {
  margin-top: 2px !important;
  margin-bottom: 2px !important;
}

.compact .v-text-field {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding-top: 0 !important;
}

.compact .v-select {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.compact .v-input {
  margin-top: 8px !important;
}
.compact .v-input >>> .v-label {
  font-size: 14px !important;
  top: 14px;
}

.compact .v-data-table {
  margin-top: 4px !important;
}

.qty_filed /deep/ .v-input__append-outer {
  margin-top: -8px !important;
}
.qty_filed .v-input {
  margin-top: 0px;
}
.qty_filed .qty_unit {
  margin: 0;
  padding: 0;
}

.qty_filed .qty_unit /deep/ label::after {
  content: "";
}

.etd-checkbox-container {
  flex-wrap: nowrap;
  gap: 0;
}

.etd-checkbox-container .v-input {
  flex-grow: 0;
  margin-right: 0;
  padding-right: 0;
}

.etd-checkbox-container .v-input__control {
  min-width: auto;
}

.etd-checkbox-container .v-input__slot {
  margin-bottom: 0;
  margin-right: 0;
}

.etd-checkbox-container .v-messages {
  display: none;
}

.etd-checkbox-container .v-input--checkbox {
  margin-right: 0;
}

.etd-checkbox-container .v-input--checkbox .v-input__control .v-input__slot .v-input--selection-controls__input {
  margin-right: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/LabelCreateImportToUsPopup.vue